import { Injectable } from '@angular/core';
var MapsAPILoader = /** @class */ (function () {
    function MapsAPILoader() {
    }
    MapsAPILoader.decorators = [
        { type: Injectable },
    ];
    return MapsAPILoader;
}());
export { MapsAPILoader };
//# sourceMappingURL=maps-api-loader.js.map


//////////////////
// WEBPACK FOOTER
// ../~/@agm/core/services/maps-api-loader/maps-api-loader.js
// module id = 94
// module chunks = 0